import type { DrawForecast } from '../../../../schema/forecast/entry.js';
import type { ISubscribeDrawForecastUseCase } from '../../../domain/entry.js';
import type { DrawQueryOptions } from '../../../lib/entry.js';
import type { ForecastData } from './getDrawResultController.js';

export type ISubscribeDrawForecastController = ReturnType<typeof subscribeDrawForecastController>;

type DrawForecastData = Extract<ForecastData, { type: 'FORECAST' }>;
type HandleForecastUpdateFn = (drawForecast: DrawForecastData) => void;

type UnsubscribeSocketFn = () => void;

/**
 * Controller to get a specific draw for a product.
 *
 * @param subscribeDrawForecastUseCase Use case to subscribe to a specific draw for forecast result data
 * @returns Controller executor function
 */
export function subscribeDrawForecastController(subscribeDrawForecastUseCase: ISubscribeDrawForecastUseCase) {
  return function controller(queryInfo: DrawQueryOptions, onUpdate?: HandleForecastUpdateFn): UnsubscribeSocketFn {
    const handleForecastUpdate = (drawForecast: DrawForecast): void => {
      if (onUpdate) {
        onUpdate({ type: 'FORECAST', data: drawForecast });
      }
    };

    return subscribeDrawForecastUseCase.execute({ ...queryInfo, onUpdate: handleForecastUpdate });
  };
}
